export default {
  title: 'Pausar disponibilidad',
  description: '¿Sin capacidad?',
  pause_availabilities: {
    pause_until_end_of_day: '¿Pausar las reservas hasta el final del día?',
    pause_specific_time: 'Pausar reservas para otro día y/u hora',
  },
  pause_reservations_today: 'Pausar reservas hoy',
  pause_reservations_another_day: 'Pausar reservas para otro día',
  paused_availabilities_form: {
    date_time: {
      label: 'Seleccionar una fecha y hora',
    },
    reason: {
      label: 'Añadir un motivo (opcional)',
      placeholder: 'Introducir descripción...',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  error_messages: {
    creation_failed: 'Error al crear la excepción',
  },
};
